export default {

  cartItemsLength(state, getters) {
    return Object.keys(state.items).length;
  },

  formDataQuotationInsert(state, getters) {

    return {

      quotation: {
        name: state.name,
        email: state.email,

        phone: state.phone,
        note: state.note,
      },

      products: _.map(state.items, function(item){

        let params = {};
        params[item.id]  = {quantity: item.quantity};

        return params;

      })

    };
  },

};
